import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './Movie.css'; // Import the external CSS
import apiRequest from '../../lib/apiRequest';
import logger from '../../lib/logger';




const Movie = () => {
  const { id } = useParams();
  const [movie, setMovie] = useState(null);
  const [loading, setLoading] = useState(true);
  // For editing keywords
  const [isEditing, setIsEditing] = useState(false);
  const [editingKeywords, setEditingKeywords] = useState('');


  // For the main image selection
  const [selectedImage, setSelectedImage] = useState(null);

  // For showing user feedback after upload
  const [uploadMessage, setUploadMessage] = useState('');

  useEffect(() => {
    const fetchMovieDetails = async () => {
      try {
        const response = await fetch(
          `https://www.eporner.com/api/v2/video/id/?id=${id}&thumbsize=medium&format=json`
        );
        const data = await response.json();

        setMovie(data);
        setSelectedImage(data.default_thumb?.src);
        // Initialize editingKeywords with the fetched keywords
        setEditingKeywords(data.keywords || '');
        setLoading(false);
        logger.log(data)
      } catch (error) {
        logger.error("Error fetching movie details:", error);
        setLoading(false);
      }
    };

    fetchMovieDetails();
  }, [id]);

  // Handle uploading new keywords to your API
  const handleUpload = async () => {
    if (!movie) return;

    try {
      // Make a POST request to your action API endpoint
      const newContext = `Title: ${movie.title}\nKeywords: ${editingKeywords}\nURL: ${movie.embed}\nId: ${movie.id}`
      const res = await apiRequest.post('/action/upload-description', {
        movieId: id,
        newContext,
      });
      logger.log(res)
      if (res.status !== 200) {
        logger.error('Upload error:', res.data?.message);
        setUploadMessage('Failed to upload your description. Please try again.');
      } else {
        // If successful, update local state
        setMovie({ ...movie, keywords: editingKeywords });
        setUploadMessage(
          'Your description has been uploaded successfully. We will review it for approval.'
        );
      }
    } catch (error) {
      logger.error('Error uploading description:', error);
      setUploadMessage('An error occurred. Please try again.');
    }

    // Close the modal regardless
    setIsEditing(false);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!movie) {
    return <div>Error: Movie details not found</div>;
  }

  return (
    <div className="movie-container">
      <h1 className="movie-title">{movie.title}</h1>

      {/* Show feedback message if any */}
      {uploadMessage && (
        <div className="upload-message">
          {uploadMessage}
        </div>
      )}

      {/* Keywords + Modify button */}
      <p className="movie-info">
        <strong>Keywords:</strong> {movie.keywords}{' '}
        <button className="modify-btn" onClick={() => setIsEditing(true)}>
          Upload Description
        </button>
      </p>

      <p className="movie-info">
        <strong>Views:</strong> {movie.views}
      </p>
      <p className="movie-info">
        <strong>Rating:</strong> {movie.rate}
      </p>
      <p className="movie-info">
        <strong>Added:</strong> {movie.added}
      </p>
      <p className="movie-info">
        <strong>Duration:</strong> {movie.length_min}
      </p>

      {/* Large image */}
      <div className="movie-large-image">
        <img src={selectedImage} alt={movie.title} />
      </div>

      <h3 className="thumbnail-heading">Thumbnails</h3>
      <div className="thumbnail-container">
        {movie.thumbs.map((thumb, index) => (
          <img
            key={index}
            src={thumb.src}
            alt={`Thumbnail ${index + 1}`}
            onClick={() => setSelectedImage(thumb.src)}
            className={`thumbnail ${
              thumb.src === selectedImage ? 'selected-thumbnail' : ''
            }`}
          />
        ))}
      </div>

      {/* Embedded video iframe */}
      <iframe
        src={movie.embed}
        title="Video Embed"
        className="movie-iframe"
        allowFullScreen
      ></iframe>

      {/* Modal for editing keywords */}
      {isEditing && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Keywords</h2>
            <textarea
              className="edit-textarea"
              value={editingKeywords}
              onChange={(e) => setEditingKeywords(e.target.value)}
              placeholder="Enter new descriptions/keywords here..."
            />
            <div className="modal-buttons">
              <button className="save-btn" onClick={handleUpload}>
                Upload
              </button>
              <button className="cancel-btn" onClick={() => setIsEditing(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Movie;
